import Vue from "vue";
import Vuex from "vuex";
import * as auth from '@/store/modules/auth.js'
import * as superadmin from '@/store/modules/superadmin.js'
import * as globaladmin from '@/store/modules/globaladmin.js'
import * as marketAdmin from '@/store/modules/marketAdmin.js'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth,
    superadmin,
    globaladmin,
    marketAdmin
  }
});
